import React from "react";
import { FaUndoAlt } from "react-icons/fa";

interface U2000CancelBtnProps {
  label: string;
  handleClick?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  handleMouseDown?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  disabled?: boolean;
}

const U2000CancelBtn: React.FC<U2000CancelBtnProps> = ({ label, handleClick, handleMouseDown, disabled }) => {
  const mouseDown = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    if (handleMouseDown) {
      handleMouseDown(e);
    }
  };

  return (
    <button
      className={`inline-flex items-center justify-center rounded-lg bg-white border border-gray-300 px-4 py-2.5 text-sm font-medium text-gray-700 shadow-xs transition-all duration-200 
        hover:bg-gray-50 hover:border-gray-400 hover:text-gray-900 hover:shadow-md 
        focus:outline-hidden focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 
        active:bg-gray-100 active:scale-95 
        disabled:cursor-not-allowed disabled:bg-gray-100 disabled:border-gray-200 disabled:text-gray-400 disabled:opacity-60 disabled:shadow-none`}
      onMouseDown={mouseDown}
      onClick={handleClick}
      disabled={disabled}
    >
      <FaUndoAlt className="mr-2 h-4 w-4 shrink-0" />
      <span>{label}</span>
    </button>
  );
};

export default U2000CancelBtn;
